<template>
  <div class="h-full flex flex-col">
    <h1 class="h-70px flex items-center border-inherit border-b-1">
      <i class="iconfont icon-bg-tool"></i>
      <span class="font-bold ml-7px">隐患整改完成排名</span>
    </h1>
    <div class="flex-auto overflow-y-auto">
      <div v-for="(item, index) in data" :key="index" class="flex h-54px items-center">
        <div
          class="w-18px h-18px rounded text-white text-12px flex justify-center items-center"
          :style="{ background: background(index + '') }"
        >
          {{ index + 1 }}
        </div>
        <div
          class="ml-10px h-full flex justify-between border-inherit border-solid border-b-1 items-center flex-auto pr-15px"
        >
          <span class="flex-auto truncate w-0 cursor-pointer" :title="item.name">{{
            item.name
          }}</span>
          <span class="w-80px text-right">{{ item.value }}次</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ranking',
  props: {
    data: {
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    background() {
      return (val) => {
        let color
        switch (val) {
          case '0':
            color = '#FF3A30'
            break
          case '1':
            color = '#FF9502'
            break
          case '2':
            color = '#00BB7A'
            break
          default:
            color = '#c7c7cc'
        }
        return color
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>
